'use client';

import ConsultantForm from '@/components/ConsultantForm';
import { Language } from '@/lib/translations';
import { ITheme } from '@/types/theme';
import type { CtaButtonsProps } from './CtaButtons';

interface ConsultantFormWrapperProps {
  language: Language;
  theme?: ITheme;
  backgroundColor?: 'primary' | 'secondary';
  primaryCtaColors?: CtaButtonsProps['primaryColors'];
}

export default function ConsultantFormWrapper({
  language,
  theme,
  primaryCtaColors,
  backgroundColor = 'primary',
}: ConsultantFormWrapperProps) {
  return (
    <ConsultantForm
      language={language}
      theme={theme}
      primaryCtaColors={primaryCtaColors}
      backgroundColor={backgroundColor}
    />
  );
}
